/**
 * Basic accordion behaviour for Coupon field.
 *
 * AJAX coupon submissions (Basket page)
 * In the original template the coupon form would live in cart.php template, nested in the form,
 * but it has been moved to the cart summary for layout purposes.
 * Because of this, the coupon field is no longer part of the Basket form and we are unable to submit
 * coupons via AJAX, requiring a separate form submission (with page load) instead.
 *
 * To get around that, we place the coupon UI elements in the cart summary but add custom JS events
 * that will populate the real field (cart.php), which is hidden, and trigger a click on the button
 * so it can submit the entire form via WooCommerce's JS hooks (AJAX).
 */
const CouponField = {
  _selectors: {
    container: '.js-coupon',
    triggerBtn: '.js-coupon-accordion-trigger',

    // Required selectors for AJAX submission
    visibleInputField: '.js-coupon-input-field',
    visibleSubmitBtn: '.js-coupon-submit-btn',
    hiddenInputFieldForSubmission: '.js-hidden-coupon-field',
    hiddenButtonForSubmission: '.js-hidden-coupon-submit-btn'
  },

  init() {
    const self = this;

    // Events need to be added to the window because when used in WooCommerce cart page,
    // the form is replaced and the events lost.
    window.addEventListener('click', e => {
      // Expands/collapses accordion
      if ( e.target.matches(self._selectors.triggerBtn) ) {
        self.toggleAccordion( e.target.closest(self._selectors.container) );
      }
    });
  },

  /**
   * Allows WC coupon field to be submitted via AJAX
   */
  initAJAXsetup() {
    const self = this;

    // Events need to be added to the window because when used in WooCommerce cart page,
    // the form is replaced and the events lost.
    window.addEventListener('click', e => {

      // AJAX Submit button
      if ( e.target.matches(self._selectors.visibleSubmitBtn) ) {
        // Prevents normal form submission
        e.preventDefault();

        const inputField = e.target.closest(self._selectors.container).querySelector( self._selectors.visibleInputField );
        self._populateAndSubmitAJAXForm( inputField );
      }
    });
  },

  toggleAccordion( el ) {
    el.classList.toggle('expand');
  },

  _populateAndSubmitAJAXForm( inputFieldEl ) {
    // Adds jQuery block UI overlay to Basket Summary which will be removed when WooCommerce replaces the form
    // in the AJAX response
    window.jQuery('.cart_totals').block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

    // Updates field that will actually be submitted in the AJAX form
    const inputFieldForSubmission = document.querySelector( this._selectors.hiddenInputFieldForSubmission );
    inputFieldForSubmission.value = inputFieldEl.value;

    // Triggers WooCommerce form submission
    document.querySelector( this._selectors.hiddenButtonForSubmission ).click();
  }
};

export default CouponField;